import { useEffect } from "react";

/**
 * Adds `<meta name="robots" content="noindex">` while mounted, so search engines drop the page.
 */
export function useNoIndex(isNoIndex = true) {
  useEffect(() => {
    if (!isNoIndex) {
      return;
    }

    const robotsMeta = document.createElement("meta");

    robotsMeta.name = "robots";
    robotsMeta.content = "noindex";
    document.head.appendChild(robotsMeta);

    return () => robotsMeta.remove();
  }, [isNoIndex]);
}
